import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { TitleDropdown } from 'components';
import { LayoutCard, Loading } from '../components';
import { useTeam, useListings } from '../hooks';
import TeamSection from '../Section/TeamSection';
import TeamListingsSection from '../Section/ListingsSection';

const TeamCard = () => {
  const {
    targetTeamId,
    availableTeamStates,
    teamUsers,
    isLoading: isTeamLoading,
  } = useTeam();

  const {
    listings,
    isLoading: isListingsLoading,
    searchValue,
    setSearchValue,
  } = useListings({
    searchType: 'team',
    targetTeamId,
    isSecondaryTeamCard: true,
  });

  const [tabKey, setTabKey] = useState('people');

  const contents: Record<string, React.ReactElement> = {
    people: isTeamLoading ? <Loading /> : <TeamSection teamUsers={teamUsers} />,
    listings: isListingsLoading ? (
      <Loading />
    ) : (
      <TeamListingsSection listings={listings} isTeamListing />
    ),
  };

  const isTeamMoreThan1 = availableTeamStates.length > 1;

  return (
    <LayoutCard
      search={
        tabKey === 'listings'
          ? { searchValue, onSearchValueChange: setSearchValue }
          : null
      }
      title={
        isTeamMoreThan1 && (
          <TitleDropdown
            type="team-card"
            mainTitleStyle={{ fontSize: '100%' }}
            itemTitleLevel={4}
          />
        )
      }
      titleLink={
        !isTeamMoreThan1 && {
          title: <span data-cy="view-all-team-listings">Team</span>,
          linkPath: '/listing/list/team/0',
        }
      }
      activeTabKey={tabKey}
      tabList={[
        { key: 'people', tab: <span data-cy="team-tab-people">People</span> },
        {
          key: 'listings',
          tab: <span data-cy="team-tab-listings">Listings</span>,
        },
      ]}
      tabProps={{
        size: 'small',
      }}
      onTabChange={setTabKey}
      actions={
        tabKey === 'listings'
          ? [<Link to="/listing/list/team/0">View All</Link>]
          : []
      }
      data-cy="dashboard-team-card"
    >
      {contents[tabKey]}
    </LayoutCard>
  );
};

export default TeamCard;
